import { render } from "./DeleteBudgetSection.vue?vue&type=template&id=64e88985"
import script from "./DeleteBudgetSection.vue?vue&type=script&lang=js"
export * from "./DeleteBudgetSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__